<template>
  <customreport :report="3" />
</template>
<script>
import '@telexpress_auth/vue-customreport/dist/components/customreport.css';
import customreport from '@telexpress_auth/vue-customreport/dist/components/customreport.umd.min';

export default {
  components: {
    customreport,
  },
};
</script>
